<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="60%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" ref="dataForm" :rules="dataRule" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="small">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="供应商" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="lifnr" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.lifnr" placeholder="供应商" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="配额" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="quote" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.quote" placeholder="配额" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="特别采购类型" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="sobin" style="margin-bottom: 0;">
                        <el-select v-model="dataForm.sobin" placeholder="请选择">
                            <el-option v-for="item in SOBIN_TYPE" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <el-row>
        <el-col style="text-align: right">
            <el-button size="small" @click="view.visible = false">
                <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
            </el-button>
            <el-button size="small" type="primary" @click="dataFormSubmit()">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    getQuotaMaterialDetailById,
    createQuotaMaterialDetail,
    editQuotaMaterialDetail,
    getUnitList,
    getFactoryList,
    getStorePositionTypeList,
} from "@/controller/systemData"
import { 
    SOBIN_TYPE,
    getSboinByValue,
} from "@/utils/const";
export default {
    data() {
        var validateNumber = (rule, value, callback) => {
            if (!(/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value)) {
                callback(new Error('请输入数字值'))
            } else {
                callback()
            }
        }
        return {
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewData: {},
            unitList: [],
            factoryList: [],
            SOBIN_TYPE : SOBIN_TYPE,
            getSboinByValue : getSboinByValue,
            storePositionTypeList: [],
            dataForm: {
                id: 0,
                lifnr: '',
                quote: '',
                sobin: '',
            },
            dataRule: {
                lifnr: [{
                    max: 10,
                    message: '长度最大10位',
                    trigger: "blur",
                },
                {
                    required: true,
                    message: '请输入供应商',
                    trigger: "blur",
                }
                ],
                quote: [{
                    validator: validateNumber,
                    trigger: "blur",
                }]
            },
        };
    },
    methods: {
        // 初始化
        init(id, historyId) {
            this.dataForm.id = id || 0;
            this.dataForm.historyId = historyId;
            this.view.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id查
                    getQuotaMaterialDetailById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
                this.getUnitList()
                this.getFactoryList()
                this.getStorePositionTypeList()
            });
        },
        // 特别采购类型
        sboinTypeFormat: function (value) {
            if (!value) {
                return "";
            }
            return getSboinByValue(SOBIN_TYPE, value);
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let detailParams = {
                        id: this.dataForm.id || undefined,
                        lifnr: this.dataForm.lifnr,
                        quote: this.dataForm.quote,
                        sobin: this.dataForm.sobin,
                    };
                    if (this.dataForm.id) {
                        editQuotaMaterialDetail(detailParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit("refreshDetailDataList");
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                    } else {
                        createQuotaMaterialDetail(detailParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshDetailDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                    }
                }
            });
        },
        //获取工厂数据
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            })
        },
        //获取单位数据
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        //获取库存地点数据
        getStorePositionTypeList() {
            getStorePositionTypeList({
                storeCode: "",
                storeAddress: "",
                storeName: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.storePositionTypeList = data.body;
                }
            });
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        handleChange(val) {
            const type = this.storePositionTypeList.find(type => type.storeAddress === val)
            this.dataForm.lgort = type ? type.storeAddress : ''
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            // return 'text-align: center'
        }
    },
};
</script>
